import ConsumerGroupUpdate from './ConsumerGroupUpdate';

export default ConsumerGroupUpdate;
